// メールのリンクの着地点: /login/callback?token=&email=。ログインを仕上げて /dashboard へ。
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router';
import { completeMagicLink, parseCallback } from '../lib/auth';
import { messageOf } from '../lib/errors';
import { Card, ErrorText, Muted } from '../components/ui';

export function LoginCallbackPage() {
  const loc = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const started = useRef(false); // StrictMode の二重実行で token を 2 回使わない

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const p = parseCallback(loc.search);
    if (!p) {
      setError('ログインリンクの形が正しくありません。もう一度リンクを送ってください。');
      return;
    }
    completeMagicLink(p.token, p.email)
      .then(() => navigate('/dashboard', { replace: true }))
      .catch((e) => setError(messageOf(e)));
  }, [loc.search, navigate]);

  return (
    <div className="flex min-h-dvh items-center justify-center bg-sidebar px-4">
      <Card className="w-full max-w-sm space-y-3 p-6">
        {error ? (
          <>
            <ErrorText>{error}</ErrorText>
            <Link to="/login" className="text-sm text-accent underline">
              ログイン画面へ戻る
            </Link>
          </>
        ) : (
          <Muted>ログインしています…</Muted>
        )}
      </Card>
    </div>
  );
}
